import FilesUploaderDialog from "./views/FilesUploaderDialog";

const routes = [
  {
    path: "/files-uploader",
    name: "files-uploader",
    component: FilesUploaderDialog,
    props: route => ({
      uploadAsRequired: route.query.uploadAsRequired === "true",
    })
  }
];

export default routes;
